import { useLocation, useNavigate } from "react-router-dom";


const useNavi = ()=>{
    const navi = useNavigate()
    const location = useLocation()
    const btnNav = ()=>{
    const prefix = location.pathname.startsWith("/promo65")
        ? "/promo65"
        : location.pathname.startsWith("/promo49")
            ? "/promo49"
            : ""
    navi(`${prefix}/eligibility`)
}
return btnNav
}
export default useNavi

